export default Object.freeze({
  // Oranges
  O50_STRAVA_ORANGE: '#FC5200',
  O60_RUST: '#CC4200',
  O40_PUMPKIN: '#FC6100',
  // Black / White
  BLACK: '#000000',
  WHITE: '#FFFFFF',
  // Neutral
  N10_FOG: '#F7F7FA',
  N20_ICICLE: '#F0F0F5',
  N30_SILVER: '#DFDFE8',
  N40_STEEL: '#B2AFC0',
  N70_GRAVEL: '#6D6D78',
  N80_ASPHALT: '#494950',
  N90_COAL: '#242428',
  // Green
  PROGRESS_GREEN: '#36C597',
  // Gold
  Y50_GOLD: '#FDC746'
});